<template>
  <v-content class="pa-0 ma-0">
    <v-timeline
      dense
      clipped
      :class="{ frame: !fullHeight }"
      v-if="!isEmpty(filteredActivityLogs)"
    >
      <div class="darkgrey--text ml-5 subheading">
        <span class="ml-3">Most Recent</span>
      </div>
      <v-timeline-item
        v-for="(log, i) in filteredActivityLogs"
        :key="log.id"
        fill-dot
        small
        color="primary"
        class="white--text"
      >
        <div
          class="text-xs-center darkgrey--text mb-2"
          v-if="
            i === 0 ||
              moment(filteredActivityLogs[i - 1].created_at).diff(
                moment(log.created_at),
                'minutes',
              ) > 30 ||
              moment(filteredActivityLogs[i - 1].created_at).date() !==
                moment(log.created_at).date()
          "
        >
          {{ moment(log.created_at).format('lll') }}
        </div>
        <v-card flat class="activity__card">
          <v-card-title class="font-weight-bold pb-0 text-xs-left">
            {{ log.title }}
          </v-card-title>
          <v-card-text>
            <v-layout column>
              <v-flex class="text-xs-left" v-html="log.description" />
            </v-layout>
          </v-card-text>
        </v-card>
      </v-timeline-item>
    </v-timeline>
    <v-layout
      class="subheading darkgrey--text text-xs-center py-5"
      column
      align-center
      v-else
    >
      <v-flex> No activities tracked. </v-flex>
    </v-layout>
  </v-content>
</template>
<script>
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
export default {
  name: 'ActivityLog',
  props: {
    fullHeight: {
      required: false,
      type: Boolean,
      default: false,
    },
    currentCompanyId: {
      required: true,
      type: Number,
    },
    dialogOpened: {
      required: true,
      type: Boolean,
    },
    typeId: {
      required: false,
      type: Number,
    },
    questionnaireId: {
      required: false,
      type: Number,
    },
  },
  data() {
    return {
      activityLogs: [],
    };
  },
  computed: {
    filteredActivityLogs() {
      if (this.typeId == 0 || this.typeId) {
        return this.activityLogs.filter(a => a.type_id === this.typeId);
      } else {
        return this.activityLogs;
      }
    },
  },
  methods: {
    isEmpty,
    moment,
    colorOfActivityLog(log) {
      if (log.type_id === '1') {
        return 'primary';
      } else {
        return 'primary';
      }
    },
    async refreshActivityLogs() {
      try {
        const response = await API.company.getActivityLogs({
          companyId: this.currentCompanyId,
          questionnaireId: this.questionnaireId,
        });
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
          console.log(response.data.error);
        } else {
          this.activityLogs = response.data.sort(a => a.created_at);
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  watch: {
    dialogOpened: {
      async handler(value) {
        this.refreshActivityLogs();
      },
      immediate: true,
    },
  },
};
</script>
<style>
.activity__card {
  border-color: #e9f4fd !important;
  background-color: #e9f4fd !important;
  /* color: #527692 !important; */
}
.frame {
  overflow: auto;
  max-height: 700px;
}

.frame::-webkit-scrollbar {
  -webkit-appearance: none;
}

.frame::-webkit-scrollbar:vertical {
  width: 11px;
}

.frame::-webkit-scrollbar:horizontal {
  height: 11px;
}

.frame::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid white; /* should match background, can't be transparent */
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
